import { registerClientComponents } from '@utils/object-util'

// import base and override (extended) components.
// REPORTS
import TEnrollmentReport from '@components/reports/enrollment-report/enrollment-report'
import WHREnrollmentReport from '@components/reports/enrollment-report/whr-enrollment-report'
import TPostEarnings from '@components/cc/transaction/post-earnings/post-earnings'
import ALGPostEarnings from '@components/cc/transaction/post-earnings/alg-post-earnings'
import TPostNonStay from '@components/cc/transaction/post-earnings/post-non-stay'
import WHRPostNonStay from '@components/cc/transaction/post-earnings/whr-post-non-stay'
import WHRPostEarnings from '@components/cc/transaction/post-earnings/whr-post-earnings'
// CC
import TAccountStatus from '@components/cc/member/account-status/account-status'
import WHRAccountStatus from '@components/cc/member/account-status/whr-account-status'
import TAddress from '@components/cc/member/address/address'
import WHRAddress from '@components/cc/member/address/whr-address'
import TEmail from '@components/cc/member/email/email'
import WHREmail from '@components/cc/member/email/whr-email'
import TCompensation from '@components/cc/compensation/compensation'
import WHRCompensation from '@components/cc/compensation/whr-compensation'
import TUpdateAccountStatus from '@components/cc/member/update-account-status/update-account-status'
import WHRUpdateAccountStatus from '@components/cc/member/update-account-status/whr-update-account-status'
import TMemberHeader from '@components/cc/member/header/header'
import CHIMemberHeader from '@components/cc/member/header/chi-header'
import WHRMemberHeader from '@components/cc/member/header/whr-header'
import TPhone from '@components/cc/member/phone/phone'
import WHRPhone from '@components/cc/member/phone/whr-phone'
import TCreditCard from '@components/cc/member/credit-card/credit-card'
import CHICreditCard from '@components/cc/member/credit-card/chi-credit-card'
import WHRCreditCard from '@components/cc/member/credit-card/whr-credit-card'
// PM
import TCreateEditEventRule from '@components/pm/rules/event-rules/create-edit-event-rule'
import WHRCreateEditEventRule from '@components/pm/rules/event-rules/whr-create-edit-event-rule'
import TTierHistory from '@components/cc/member/tier-history/tier-history'
import TWhrTierHistory from '@components/cc/member/tier-history/whr-tier-history'

let settings = {}

if (typeof window !== 'undefined' && window.twa?.settings) {
  settings = window.twa.settings
} else {
  console.error('window.twa.settings is not defined')
}

const clientCode = settings?.clientProgramCode?.toLowerCase() || ''

// Map of components to register
const componentMappings = {
  't-account-status': {
    base: TAccountStatus,
    override: {
      whr: WHRAccountStatus,
    },
  },
  't-address': {
    base: TAddress,
    override: {
      whr: WHRAddress,
    },
  },
  't-email': {
    base: TEmail,
    override: {
      whr: WHREmail,
    },
  },
  't-enrollment-report': {
    base: TEnrollmentReport,
    override: {
      whr: WHREnrollmentReport,
    },
  },
  't-post-earnings': {
    base: TPostEarnings,
    override: {
      alg: ALGPostEarnings,
      whr: WHRPostEarnings,
    },
  },
  't-post-non-stay': {
    base: TPostNonStay,
    override: {
      whr: WHRPostNonStay,
    },
  },
  't-update-account-status': {
    base: TUpdateAccountStatus,
    override: {
      whr: WHRUpdateAccountStatus,
    },
  },
  't-member-header': {
    base: TMemberHeader,
    override: {
      chi: CHIMemberHeader,
      whr: WHRMemberHeader,
    },
  },
  't-phone': {
    base: TPhone,
    override: {
      whr: WHRPhone,
    },
  },
  't-credit-card': {
    base: TCreditCard,
    override: {
      chi: CHICreditCard,
      whr: WHRCreditCard,
    },
  },
  't-compensation': {
    base: TCompensation,
    override: {
      whr: WHRCompensation,
    },
  },
  't-create-edit-event-rule': {
    base: TCreateEditEventRule,
    override: {
      whr: WHRCreateEditEventRule,
    },
  },
  't-tier-history': {
    base: TTierHistory,
    override: {
      whr: TWhrTierHistory,
    },
  },
}

// Register all reports dynamically
registerClientComponents(clientCode, componentMappings)
